import React, { useEffect, useContext } from "react";
import { Section, SidebarLayout } from "../../../../../../components/shared";
import { MainMenu } from "../../../../../../components/coordinator/shared";
import {
  ServicesMonitoringPanedTables
} from "../../../../../../components/admin/experts/services/monitoring";
import {
  MenuContext,
  ServiceDetailModalProvider
} from "../../../../../../contexts/shared";

export function TrackingMonitoringServicesIndex() {
  const { setMenuState } = useContext(MenuContext);

  /* set menu's current state */
  useEffect(() => {
    setMenuState({
      openKeys: ["experts"],
      selectedKeys: ["experts/services/monitoring/assignations"]
    });
  }, []);

  return (
    <ServiceDetailModalProvider refetch={() => undefined}>
      <SidebarLayout menu={<MainMenu />}>
        <Section spaced>
          <ServicesMonitoringPanedTables
            tableType="TRACKING" />
        </Section>
      </SidebarLayout>
    </ServiceDetailModalProvider>
  );
}